// import React, { useState } from "react";
// import {
//   BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, LabelList, ResponsiveContainer,
//   LineChart, Line, PieChart, Pie, Cell, ScatterChart, Scatter, AreaChart, Area, Treemap
// } from "recharts";

// // Parse CSV to array of objects
// export function parseCSV(csv) {
//   const lines = csv.trim().split("\n");
//   if (lines.length < 2) return [];
//   const headers = lines[0].split(",").map(h => h.trim());
//   return lines.slice(1).map(line => {
//     const values = line.split(",").map(v => v.trim());
//     return Object.fromEntries(headers.map((h, i) => [h, values[i]]));
//   });
// }

// const COLORS = [
//   "#2799fa", "#9358fe", "#2fdebf", "#fcbe43", "#f85050",
//   "#ffaa4e", "#3dc49d", "#5866eb"
// ];

// const CHART_TYPE_OPTIONS = [
//   { key: "bar_chart", label: "Bar Chart" },
//   { key: "horizontal_bar_chart", label: "Horizontal Bar Chart" },
//   { key: "line_chart", label: "Line Chart" },
//   { key: "area_chart", label: "Area Chart" },
//   { key: "pie_chart", label: "Pie Chart" },
//   { key: "donut_chart", label: "Donut Chart" },
//   { key: "scatter_plot", label: "Scatter Plot" },
//   { key: "treemap", label: "Treemap" }
// ];

// export function UniversalChatChart({ chartSpec, csv }) {
//   const data = parseCSV(csv);

//   // Always call hooks at the top
//   const headers = Object.keys(data[0] || {});
//   const [chartType, setChartType] = useState(chartSpec?.chart_type || "bar_chart");
//   const [xAxis, setXAxis] = useState(chartSpec?.x_axis || headers[0]);
//   const [yAxis, setYAxis] = useState(chartSpec?.y_axis || headers[1] || headers[0]);

//   if (!chartSpec || !data.length) return null;

//   // Unique IDs for accessibility
//   const chartTypeId = `chart-type-${Math.random().toString(32).slice(2, 9)}`;
//   const xAxisId = `x-axis-${Math.random().toString(32).slice(2, 9)}`;
//   const yAxisId = `y-axis-${Math.random().toString(32).slice(2, 9)}`;

//   const axisLabelStyle = { fill: "#516290", fontSize: 13.2, fontWeight: 500 };
//   const getSeriesKeys = () => chartSpec?.series || headers.filter(h => h !== xAxis && h !== yAxis);

//   // Convert numeric strings into numbers where possible
//   const numify = obj =>
//     Object.fromEntries(
//       Object.entries(obj).map(([k, v]) => [
//         k,
//         Number.isNaN(Number(v)) ? v : Number(v)
//       ])
//     );
//   const numData = data.map(numify);

//   return (
//     <div
//       style={{
//         margin: "15px 0 6px",
//         padding: "22px 20px 26px 24px",
//         background: "linear-gradient(100deg, #f8fafd 80%, #e3edfa 120%)",
//         border: "1.5px solid #d2e3f5",
//         borderRadius: 7,
//         boxShadow: "0 8px 32px #aac4e636",
//         position: "relative",
//         width: "100%",
//       }}
//     >
//       {/* Title + Dropdowns */}
//       <div
//         style={{
//           fontWeight: 700,
//           fontSize: 18,
//           letterSpacing: ".01em",
//           color: "#2b3d75",
//           paddingBottom: 10,
//           lineHeight: 1.35
//         }}
//       >
//         <span>{chartSpec.title || "Chart"}</span>
//         <span style={{ float: "right", display: "flex", gap: 8 }}>
//           <label
//             htmlFor={chartTypeId}
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               fontSize: 13.5,
//               color: "#3b5a84",
//               fontWeight: 500,
//               gap: 4
//             }}
//           >
//             Chart:
//             <select
//               id={chartTypeId}
//               value={chartType}
//               onChange={e => setChartType(e.target.value)}
//               style={{
//                 marginLeft: 5,
//                 fontSize: 13,
//                 padding: "2px 8px",
//                 borderRadius: 6,
//                 border: "1.1px solid #b3d1fc",
//                 background: "#f5f9ff",
//                 color: "#1566c2",
//                 fontWeight: 600
//               }}
//             >
//               {CHART_TYPE_OPTIONS.map(opt => (
//                 <option key={opt.key} value={opt.key}>
//                   {opt.label}
//                 </option>
//               ))}
//             </select>
//           </label>

//           <label
//             htmlFor={xAxisId}
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               fontSize: 13.5,
//               color: "#3b5a84",
//               fontWeight: 500,
//               gap: 4,
//               marginLeft: 8,
//               userSelect: "none"
//             }}
//           >
//             X axis:
//             <select
//               id={xAxisId}
//               value={xAxis}
//               onChange={e => setXAxis(e.target.value)}
//               style={{
//                 marginLeft: 5,
//                 fontSize: 13,
//                 padding: "2px 8px",
//                 borderRadius: 6,
//                 border: "1.1px solid #b3d1fc",
//                 background: "#f5f9ff",
//                 color: "#1566c2",
//                 fontWeight: 600
//               }}
//             >
//               {headers.map(h => (
//                 <option key={h} value={h}>
//                   {h}
//                 </option>
//               ))}
//             </select>
//           </label>

//           <label
//             htmlFor={yAxisId}
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               fontSize: 13.5,
//               color: "#3b5a84",
//               fontWeight: 500,
//               gap: 4,
//               marginLeft: 8,
//               userSelect: "none"
//             }}
//           >
//             Y axis:
//             <select
//               id={yAxisId}
//               value={yAxis}
//               onChange={e => setYAxis(e.target.value)}
//               style={{
//                 marginLeft: 5,
//                 fontSize: 13,
//                 padding: "2px 8px",
//                 borderRadius: 6,
//                 border: "1.1px solid #b3d1fc",
//                 background: "#f5f9ff",
//                 color: "#1566c2",
//                 fontWeight: 600
//               }}
//             >
//               {headers.map(h => (
//                 <option key={h} value={h}>
//                   {h}
//                 </option>
//               ))}
//             </select>
//           </label>
//         </span>
//       </div>

//       {/* Chart container */}
//       <div style={{ width: "100%", minHeight: 220, marginTop: 14 }}>
//         {/* Bar Chart */}
//         {chartType === "bar_chart" && (
//           <ResponsiveContainer width="100%" height={38 * Math.max(3, numData.length)}>
//             <BarChart data={numData}>
//               <CartesianGrid strokeDasharray="2 7" />
//               <XAxis
//                 dataKey={xAxis}
//                 label={{ value: xAxis, position: "bottom", ...axisLabelStyle, dy: 18 }}
//                 tick={{ fontSize: 13, fill: "#2d4268" }}
//               />
//               <YAxis
//                 dataKey={yAxis}
//                 label={{ value: yAxis, angle: -90, position: "left", ...axisLabelStyle, dx: -32 }}
//                 tick={{ fontSize: 14, fill: "#2d4268" }}
//               />
//               <Tooltip />
//               <Bar dataKey={yAxis} fill={COLORS[0]} barSize={24}>
//                 <LabelList dataKey={yAxis} position="top" fill="#2769d9" fontSize={13.5} />
//               </Bar>
//             </BarChart>
//           </ResponsiveContainer>
//         )}

//         {/* Horizontal Bar Chart */}
//         {chartType === "horizontal_bar_chart" && (
//           <ResponsiveContainer width="100%" height={40 * Math.max(3, numData.length)}>
//             <BarChart data={numData} layout="vertical">
//               <CartesianGrid strokeDasharray="2 7" vertical={false} />
//               <XAxis
//                 type="number"
//                 dataKey={xAxis}
//                 label={{ value: xAxis, position: "insideBottomRight", ...axisLabelStyle, dy: 12 }}
//               />
//               <YAxis
//                 type="category"
//                 dataKey={yAxis}
//                 width={150}
//                 label={{ value: yAxis, angle: -90, position: "insideLeft", ...axisLabelStyle, dx: -36 }}
//               />
//               <Tooltip />
//               <Bar dataKey={xAxis} fill={COLORS[0]} barSize={24}>
//                 <LabelList dataKey={xAxis} position="right" fill="#195adf" fontSize={13.5} />
//               </Bar>
//             </BarChart>
//           </ResponsiveContainer>
//         )}

//         {/* Line Chart */}
//         {chartType === "line_chart" && (
//           <ResponsiveContainer width="100%" height={320}>
//             <LineChart data={numData}>
//               <CartesianGrid strokeDasharray="2 7" />
//               <XAxis dataKey={xAxis} label={{ value: xAxis, position: "bottom", ...axisLabelStyle, dy: 18 }} />
//               <YAxis dataKey={yAxis} label={{ value: yAxis, angle: -90, position: "left", ...axisLabelStyle, dx: -32 }} />
//               <Tooltip />
//               <Line type="monotone" dataKey={yAxis} stroke={COLORS[0]} strokeWidth={2.4} dot={false} />
//             </LineChart>
//           </ResponsiveContainer>
//         )}

//         {/* Area Chart */}
//         {chartType === "area_chart" && (
//           <ResponsiveContainer width="100%" height={320}>
//             <AreaChart data={numData}>
//               <CartesianGrid strokeDasharray="2 7" />
//               <XAxis dataKey={xAxis} label={{ value: xAxis, position: "bottom", ...axisLabelStyle, dy: 18 }} />
//               <YAxis dataKey={yAxis} label={{ value: yAxis, angle: -90, position: "left", ...axisLabelStyle, dx: -32 }} />
//               <Tooltip />
//               <Area type="monotone" dataKey={yAxis} stroke={COLORS[0]} fill={COLORS[0]} fillOpacity={0.28} strokeWidth={2} />
//             </AreaChart>
//           </ResponsiveContainer>
//         )}

//         {/* Pie Chart / Donut Chart */}
//         {(chartType === "pie_chart" || chartType === "donut_chart") && (() => {
//           const valKey = xAxis;
//           const nameKey = yAxis;
//           return (
//             <ResponsiveContainer width="100%" height={320}>
//               <PieChart>
//                 <Pie
//                   data={numData}
//                   dataKey={valKey}
//                   nameKey={nameKey}
//                   cx="50%"
//                   cy="50%"
//                   outerRadius={110}
//                   innerRadius={chartType === "donut_chart" ? 65 : 0}
//                   fill={COLORS[0]}
//                   label
//                 >
//                   {numData.map((entry, idx) => (
//                     <Cell key={idx} fill={COLORS[idx % COLORS.length]} />
//                   ))}
//                 </Pie>
//                 <Tooltip />
//               </PieChart>
//             </ResponsiveContainer>
//           );
//         })()}

//         {/* Scatter Plot */}
//         {chartType === "scatter_plot" && (
//           <ResponsiveContainer width="100%" height={320}>
//             <ScatterChart>
//               <CartesianGrid />
//               <XAxis dataKey={xAxis} type="number" label={{ value: xAxis, position: "bottom", ...axisLabelStyle, dy: 18 }} />
//               <YAxis dataKey={yAxis} type="number" label={{ value: yAxis, angle: -90, position: "left", ...axisLabelStyle, dx: -32 }} />
//               <Tooltip />
//               <Scatter data={numData} fill={COLORS[0]} />
//             </ScatterChart>
//           </ResponsiveContainer>
//         )}

//         {/* Treemap */}
//         {chartType === "treemap" && (
//           <ResponsiveContainer width="100%" height={320}>
//             <Treemap
//               data={numData}
//               dataKey={xAxis}
//               nameKey={yAxis}
//               ratio={4 / 3}
//               stroke="#fff"
//               fill={COLORS[0]}
//             />
//           </ResponsiveContainer>
//         )}
//       </div>
//     </div>
//   );
// }


// import React, { useState } from "react";
// import {
//   BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, LabelList, ResponsiveContainer,
//   LineChart, Line, PieChart, Pie, Cell, ScatterChart, Scatter, AreaChart, Area, Treemap
// } from "recharts";

// // Parse CSV to array of objects
// export function parseCSV(csv) {
//   const lines = csv.trim().split("\n");
//   if (lines.length < 2) return [];
//   const headers = lines[0].split(",").map(h => h.trim());
//   return lines.slice(1).map(line => {
//     const values = line.split(",").map(v => v.trim());
//     return Object.fromEntries(headers.map((h, i) => [h, values[i]]));
//   });
// }

// const COLORS = [
//   "#2799fa", "#9358fe", "#2fdebf", "#fcbe43", "#f85050",
//   "#ffaa4e", "#3dc49d", "#5866eb"
// ];

// const CHART_TYPE_OPTIONS = [
//   { key: "bar_chart", label: "Bar Chart" },
//   { key: "horizontal_bar_chart", label: "Horizontal Bar Chart" },
//   { key: "line_chart", label: "Line Chart" },
//   { key: "area_chart", label: "Area Chart" },
//   { key: "pie_chart", label: "Pie Chart" },
//   { key: "donut_chart", label: "Donut Chart" },
//   { key: "scatter_plot", label: "Scatter Plot" },
//   { key: "treemap", label: "Treemap" }
// ];

// const selectStyle = {
//   marginLeft: 7,
//   fontSize: 13.4,
//   padding: "3px 12px",
//   borderRadius: 7,
//   border: "1.1px solid #b3d1fc",
//   background: "#f5f9ff",
//   color: "#1566c2",
//   fontWeight: 600
// };

// const controlLabelStyle = {
//   display: "inline-flex",
//   alignItems: "center",
//   fontSize: 14,
//   color: "#3b5a84",
//   fontWeight: 500,
//   gap: 6,
//   userSelect: "none",
// };

// export function UniversalChatChart({ chartSpec, csv }) {
//   const data = parseCSV(csv);
//   // Always place ALL hooks at the top, before any conditionals
//   const headers = Object.keys(data[0] || {});
//   const [chartType, setChartType] = useState(chartSpec?.chart_type || "bar_chart");
//   const [xAxis, setXAxis] = useState(chartSpec?.x_axis || headers[0]);
//   const [yAxis, setYAxis] = useState(chartSpec?.y_axis || headers[1] || headers[0]);
//   const chartTypeId = `chart-type-${Math.random().toString(32).slice(2, 9)}`;
//   const xAxisId = `x-axis-${Math.random().toString(32).slice(2, 9)}`;
//   const yAxisId = `y-axis-${Math.random().toString(32).slice(2, 9)}`;

//   // Now safe: after hooks, early return for missing spec or data
//   if (!chartSpec || !data.length) return null;

//   const axisLabelStyle = { fill: "#516290", fontSize: 13.5, fontWeight: 500 };
//   // Convert numeric strings into numbers where possible
//   const numify = obj =>
//     Object.fromEntries(
//       Object.entries(obj).map(([k, v]) => [
//         k,
//         Number.isNaN(Number(v)) ? v : Number(v)
//       ])
//     );
//   const numData = data.map(numify);

//   return (
//     <div
//       style={{
//         margin: "20px 0 8px",
//         padding: "24px 24px 28px",
//         backgroundColor: "#f6fbff",
//         border: "1.5px solid #d6e7fa",
//         borderRadius: 10,
//         boxShadow: "0 6px 20px #bfd3ea29",
//         width: "100%",
//         minHeight: 420,
//         position: "relative",
//       }}
//     >
//       {/* Title */}
//       <div
//         style={{
//           fontWeight: 700,
//           fontSize: 20,
//           letterSpacing: ".01em",
//           color: "#223566",
//           paddingBottom: 12,
//           lineHeight: 1.3,
//           borderBottom: "1.1px solid #ebeff3",
//           marginBottom: 20,
//         }}
//       >
//         {chartSpec.title || "Chart"}
//       </div>
//       {/* Chart controls */}
//       <div
//         style={{
//           display: "flex",
//           flexWrap: "wrap",
//           gap: 16,
//           alignItems: "center",
//           marginBottom: 16,
//         }}
//       >
//         <label htmlFor={chartTypeId} style={controlLabelStyle}>Chart:
//           <select
//             id={chartTypeId}
//             value={chartType}
//             onChange={e => setChartType(e.target.value)}
//             style={selectStyle}
//           >
//             {CHART_TYPE_OPTIONS.map(opt =>
//               <option key={opt.key} value={opt.key}>
//                 {opt.label}
//               </option>
//             )}
//           </select>
//         </label>
//         <label htmlFor={xAxisId} style={controlLabelStyle}>X&nbsp;axis:
//           <select
//             id={xAxisId}
//             value={xAxis}
//             onChange={e => setXAxis(e.target.value)}
//             style={selectStyle}
//           >
//             {headers.map(h =>
//               <option key={h} value={h}>{h}</option>
//             )}
//           </select>
//         </label>
//         <label htmlFor={yAxisId} style={controlLabelStyle}>Y&nbsp;axis:
//           <select
//             id={yAxisId}
//             value={yAxis}
//             onChange={e => setYAxis(e.target.value)}
//             style={selectStyle}
//           >
//             {headers.map(h =>
//               <option key={h} value={h}>{h}</option>
//             )}
//           </select>
//         </label>
//       </div>

//       {/* Chart area */}
//       <div style={{ width: "99%", minHeight: 248 }}>
//         {chartType === "bar_chart" && (
//           <ResponsiveContainer width="100%" height={38 * Math.max(3, numData.length)}>
//             <BarChart data={numData}>
//               <CartesianGrid strokeDasharray="2 7" />
//               <XAxis
//                 dataKey={xAxis}
//                 label={{ value: xAxis, position: "bottom", ...axisLabelStyle, dy: 18 }}
//                 tick={{ fontSize: 13, fill: "#2d4268" }}
//               />
//               <YAxis
//                 dataKey={yAxis}
//                 label={{ value: yAxis, angle: -90, position: "left", ...axisLabelStyle, dx: -32 }}
//                 tick={{ fontSize: 14, fill: "#2d4268" }}
//               />
//               <Tooltip />
//               <Bar dataKey={yAxis} fill={COLORS[0]} barSize={24}>
//                 <LabelList dataKey={yAxis} position="top" fill="#2769d9" fontSize={13.5} />
//               </Bar>
//             </BarChart>
//           </ResponsiveContainer>
//         )}

//         {chartType === "horizontal_bar_chart" && (
//           <ResponsiveContainer width="100%" height={40 * Math.max(3, numData.length)}>
//             <BarChart data={numData} layout="vertical">
//               <CartesianGrid strokeDasharray="2 7" vertical={false} />
//               <XAxis
//                 type="number"
//                 dataKey={xAxis}
//                 label={{ value: xAxis, position: "insideBottomRight", ...axisLabelStyle, dy: 12 }}
//               />
//               <YAxis
//                 type="category"
//                 dataKey={yAxis}
//                 width={150}
//                 label={{ value: yAxis, angle: -90, position: "insideLeft", ...axisLabelStyle, dx: -36 }}
//               />
//               <Tooltip />
//               <Bar dataKey={xAxis} fill={COLORS[0]} barSize={24}>
//                 <LabelList dataKey={xAxis} position="right" fill="#195adf" fontSize={13.5} />
//               </Bar>
//             </BarChart>
//           </ResponsiveContainer>
//         )}

//         {chartType === "line_chart" && (
//           <ResponsiveContainer width="100%" height={320}>
//             <LineChart data={numData}>
//               <CartesianGrid strokeDasharray="2 7" />
//               <XAxis dataKey={xAxis} label={{ value: xAxis, position: "bottom", ...axisLabelStyle, dy: 18 }} />
//               <YAxis dataKey={yAxis} label={{ value: yAxis, angle: -90, position: "left", ...axisLabelStyle, dx: -32 }} />
//               <Tooltip />
//               <Line type="monotone" dataKey={yAxis} stroke={COLORS[0]} strokeWidth={2.4} dot={false} />
//             </LineChart>
//           </ResponsiveContainer>
//         )}

//         {chartType === "area_chart" && (
//           <ResponsiveContainer width="100%" height={320}>
//             <AreaChart data={numData}>
//               <CartesianGrid strokeDasharray="2 7" />
//               <XAxis dataKey={xAxis} label={{ value: xAxis, position: "bottom", ...axisLabelStyle, dy: 18 }} />
//               <YAxis dataKey={yAxis} label={{ value: yAxis, angle: -90, position: "left", ...axisLabelStyle, dx: -32 }} />
//               <Tooltip />
//               <Area type="monotone" dataKey={yAxis} stroke={COLORS[0]} fill={COLORS[0]} fillOpacity={0.28} strokeWidth={2} />
//             </AreaChart>
//           </ResponsiveContainer>
//         )}

//         {(chartType === "pie_chart" || chartType === "donut_chart") && (() => {
//           const valKey = xAxis;
//           const nameKey = yAxis;
//           return (
//             <ResponsiveContainer width="100%" height={320}>
//               <PieChart>
//                 <Pie
//                   data={numData}
//                   dataKey={valKey}
//                   nameKey={nameKey}
//                   cx="50%"
//                   cy="50%"
//                   outerRadius={110}
//                   innerRadius={chartType === "donut_chart" ? 65 : 0}
//                   fill={COLORS[0]}
//                   label
//                 >
//                   {numData.map((entry, idx) => (
//                     <Cell key={idx} fill={COLORS[idx % COLORS.length]} />
//                   ))}
//                 </Pie>
//                 <Tooltip />
//               </PieChart>
//             </ResponsiveContainer>
//           );
//         })()}

//         {chartType === "scatter_plot" && (
//           <ResponsiveContainer width="100%" height={320}>
//             <ScatterChart>
//               <CartesianGrid />
//               <XAxis dataKey={xAxis} type="number" label={{ value: xAxis, position: "bottom", ...axisLabelStyle, dy: 18 }} />
//               <YAxis dataKey={yAxis} type="number" label={{ value: yAxis, angle: -90, position: "left", ...axisLabelStyle, dx: -32 }} />
//               <Tooltip />
//               <Scatter data={numData} fill={COLORS[0]} />
//             </ScatterChart>
//           </ResponsiveContainer>
//         )}

//         {chartType === "treemap" && (
//           <ResponsiveContainer width="100%" height={320}>
//             <Treemap
//               data={numData}
//               dataKey={xAxis}
//               nameKey={yAxis}
//               ratio={4 / 3}
//               stroke="#fff"
//               fill={COLORS[0]}
//             />
//           </ResponsiveContainer>
//         )}
//       </div>
//     </div>
//   );
// }


import React, { useState } from "react";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, LabelList, ResponsiveContainer,
  LineChart, Line, PieChart, Pie, Cell, ScatterChart, Scatter, AreaChart, Area, Treemap
} from "recharts";

// Parse CSV to array of objects
export function parseCSV(csv) {
  const lines = csv.trim().split("\n");
  if (lines.length < 2) return [];
  const headers = lines[0].split(",").map(h => h.trim());
  return lines.slice(1).map(line => {
    const values = line.split(",").map(v => v.trim());
    return Object.fromEntries(headers.map((h, i) => [h, values[i]]));
  });
}

const COLORS = [
  "#2799fa", "#9358fe", "#2fdebf", "#fcbe43", "#f85050",
  "#ffaa4e", "#3dc49d", "#5866eb"
];

const CHART_TYPE_OPTIONS = [
  { key: "bar_chart", label: "Bar Chart" },
  { key: "horizontal_bar_chart", label: "Horizontal Bar Chart" },
  { key: "line_chart", label: "Line Chart" },
  { key: "area_chart", label: "Area Chart" },
  { key: "pie_chart", label: "Pie Chart" },
  { key: "donut_chart", label: "Donut Chart" },
  { key: "scatter_plot", label: "Scatter Plot" },
  { key: "treemap", label: "Treemap" }
];

const selectStyle = {
  marginLeft: 8,
  fontSize: 14,
  padding: "8px 18px 8px 8px",
  borderRadius: 7,
  border: "1.2px solid #b3d1fc",
  background: "#fafdff",
  color: "#1957a7",
  fontWeight: 600,
  boxShadow: "0 2px 4px #e3eefc42"
};

const controlLabelStyle = {
  display: "inline-flex",
  alignItems: "center",
  fontSize: 15,
  color: "#3b5a84",
  fontWeight: 500,
  gap: 7,
  userSelect: "none"
};

export function UniversalChatChart({ chartSpec, csv }) {
  const data = parseCSV(csv);
  const headers = Object.keys(data[0] || {});
  const [chartType, setChartType] = useState(chartSpec?.chart_type || "bar_chart");
  const [xAxis, setXAxis] = useState(chartSpec?.x_axis || headers[0]);
  const [yAxis, setYAxis] = useState(chartSpec?.y_axis || headers[1] || headers[0]);
  const chartTypeId = `chart-type-${Math.random().toString(32).slice(2, 9)}`;
  const xAxisId = `x-axis-${Math.random().toString(32).slice(2, 9)}`;
  const yAxisId = `y-axis-${Math.random().toString(32).slice(2, 9)}`;

  if (!chartSpec || !data.length) return null;

  const axisLabelStyle = { fill: "#516290", fontSize: 13.5, fontWeight: 500 };
  // Convert numeric strings into numbers where possible
  const numify = obj =>
    Object.fromEntries(
      Object.entries(obj).map(([k, v]) => [
        k,
        Number.isNaN(Number(v)) ? v : Number(v)
      ])
    );
  const numData = data.map(numify);

  return (
    <div
      style={{
        margin: "22px 0 12px",
        padding: "28px 26px 32px",
        backgroundColor : "#f8fbff",
        border: "1.7px solid #cfdcf3",
        borderRadius: 14,
        boxShadow: "0 8px 30px #bfd3ea18",
        minWidth: 320,
        width: "100%",
        minHeight: 430,
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}
    >
      {/* Title */}
      <div
        style={{
          fontWeight: 750,
          fontSize: 22,
          letterSpacing: ".01em",
          color: "#1e2e4f",
          paddingBottom: 14,
          lineHeight: 1.32,
          borderBottom: "1.1px solid #ebeff3",
          marginBottom: 23,
          width: "100%",
          textAlign: "left"
        }}
      >
        {chartSpec.title || "Chart"}
      </div>

      {/* Chart type selector above the chart */}
      <div style={{
        display: "flex",
        alignItems: "center",
        marginBottom: 12,
        justifyContent: "center",
        width: "100%"
      }}>
        <label htmlFor={chartTypeId} style={controlLabelStyle}>
          Chart Type:
          <select
            id={chartTypeId}
            value={chartType}
            onChange={e => setChartType(e.target.value)}
            style={selectStyle}
          >
            {CHART_TYPE_OPTIONS.map(opt =>
              <option key={opt.key} value={opt.key}>
                {opt.label}
              </option>
            )}
          </select>
        </label>
      </div>
 <div
        style={{
          width: "100%",
          marginTop: 6,
          marginBottom: 24,
          display: "flex",
          justifyContent: "center",
          gap: 38
        }}
      >
        <label htmlFor={xAxisId} style={controlLabelStyle}>
          X Axis:
          <select
            id={xAxisId}
            value={xAxis}
            onChange={e => setXAxis(e.target.value)}
            style={selectStyle}
          >
            {headers.map(h =>
              <option key={h} value={h}>{h}</option>
            )}
          </select>
        </label>
        <label htmlFor={yAxisId} style={controlLabelStyle}>
          Y Axis:
          <select
            id={yAxisId}
            value={yAxis}
            onChange={e => setYAxis(e.target.value)}
            style={selectStyle}
          >
            {headers.map(h =>
              <option key={h} value={h}>{h}</option>
            )}
          </select>
        </label>
      </div>
      {/* Main chart visualization */}
      <div style={{
        width: "100%",
        minHeight: 255,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
        {chartType === "bar_chart" && (
          <ResponsiveContainer width="80%" height={38 * Math.max(3, numData.length)}>
            <BarChart data={numData}>
              <CartesianGrid strokeDasharray="2 7" />
              <XAxis
                dataKey={xAxis}
                label={{ value: xAxis, position: "bottom", ...axisLabelStyle, dy: 18 }}
                tick={{ fontSize: 13, fill: "#2d4268" }}
              />
              <YAxis
                dataKey={yAxis}
                label={{ value: yAxis, angle: -90, position: "left", ...axisLabelStyle, dx: -32 }}
                tick={{ fontSize: 14, fill: "#2d4268" }}
              />
              <Tooltip />
              <Bar dataKey={yAxis} fill={COLORS[0]} barSize={24}>
                <LabelList dataKey={yAxis} position="top" fill="#2769d9" fontSize={13.5} />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        )}

        {chartType === "horizontal_bar_chart" && (
          <ResponsiveContainer width="80%" height={40 * Math.max(3, numData.length)}>
            <BarChart data={numData} layout="vertical">
              <CartesianGrid strokeDasharray="2 7" vertical={false} />
              <XAxis
                type="number"
                dataKey={xAxis}
                label={{ value: xAxis, position: "insideBottomRight", ...axisLabelStyle, dy: 12 }}
              />
              <YAxis
                type="category"
                dataKey={yAxis}
                width={150}
                label={{ value: yAxis, angle: -90, position: "insideLeft", ...axisLabelStyle, dx: -36 }}
              />
              <Tooltip />
              <Bar dataKey={xAxis} fill={COLORS[0]} barSize={24}>
                <LabelList dataKey={xAxis} position="right" fill="#195adf" fontSize={13.5} />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        )}

        {chartType === "line_chart" && (
          <ResponsiveContainer width="80%" height={320}>
            <LineChart data={numData}>
              <CartesianGrid strokeDasharray="2 7" />
              <XAxis dataKey={xAxis} label={{ value: xAxis, position: "bottom", ...axisLabelStyle, dy: 18 }} />
              <YAxis dataKey={yAxis} label={{ value: yAxis, angle: -90, position: "left", ...axisLabelStyle, dx: -32 }} />
              <Tooltip />
              <Line type="monotone" dataKey={yAxis} stroke={COLORS[0]} strokeWidth={2.4} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        )}

        {chartType === "area_chart" && (
          <ResponsiveContainer width="80%" height={320}>
            <AreaChart data={numData}>
              <CartesianGrid strokeDasharray="2 7" />
              <XAxis dataKey={xAxis} label={{ value: xAxis, position: "bottom", ...axisLabelStyle, dy: 18 }} />
              <YAxis dataKey={yAxis} label={{ value: yAxis, angle: -90, position: "left", ...axisLabelStyle, dx: -32 }} />
              <Tooltip />
              <Area type="monotone" dataKey={yAxis} stroke={COLORS[0]} fill={COLORS[0]} fillOpacity={0.28} strokeWidth={2} />
            </AreaChart>
          </ResponsiveContainer>
        )}

        {(chartType === "pie_chart" || chartType === "donut_chart") && (() => {
          const valKey = xAxis;
          const nameKey = yAxis;
          return (
            <ResponsiveContainer width="80%" height={320}>
              <PieChart>
                <Pie
                  data={numData}
                  dataKey={valKey}
                  nameKey={nameKey}
                  cx="50%"
                  cy="50%"
                  outerRadius={110}
                  innerRadius={chartType === "donut_chart" ? 65 : 0}
                  fill={COLORS[0]}
                  label
                >
                  {numData.map((entry, idx) => (
                    <Cell key={idx} fill={COLORS[idx % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          );
        })()}

        {chartType === "scatter_plot" && (
          <ResponsiveContainer width="80%" height={320}>
            <ScatterChart>
              <CartesianGrid />
              <XAxis dataKey={xAxis} type="number" label={{ value: xAxis, position: "bottom", ...axisLabelStyle, dy: 18 }} />
              <YAxis dataKey={yAxis} type="number" label={{ value: yAxis, angle: -90, position: "left", ...axisLabelStyle, dx: -32 }} />
              <Tooltip />
              <Scatter data={numData} fill={COLORS[0]} />
            </ScatterChart>
          </ResponsiveContainer>
        )}

        {chartType === "treemap" && (
          <ResponsiveContainer width="80%" height={320}>
            <Treemap
              data={numData}
              dataKey={xAxis}
              nameKey={yAxis}
              ratio={4 / 3}
              stroke="#fff"
              fill={COLORS[0]}
            />
          </ResponsiveContainer>
        )}
      </div>

  
     
    </div>
  );
}
